<div id="world" [hidden]="hiddenCavans">
  <canvas id="canvas" #canvas ></canvas>
</div>

<div class="loadingBar" *ngIf="hiddenCavans && !marmoset3D" #loadingBar>
  <div style="width: 50%">
    <div style="text-align: center;">
      <p style="color: white">{{loadValue}} %</p>
    </div>
    <mat-progress-bar mode="buffer" [value]="loadValue"></mat-progress-bar>
  </div>
</div>

<div id="myviewerMap"></div>
